import { render, staticRenderFns } from "./discoverNorthAmerica.vue?vue&type=template&id=56be42b0&scoped=true&"
import script from "./discoverNorthAmerica.vue?vue&type=script&lang=js&"
export * from "./discoverNorthAmerica.vue?vue&type=script&lang=js&"
import style0 from "./discoverNorthAmerica.vue?vue&type=style&index=0&id=56be42b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be42b0",
  null
  
)

export default component.exports